import { Edit } from 'react-admin';
import { TicketQueueForm } from './index';
import { EditToolbar } from '@components/EditToolbar';
import { useTicketQueueErrorHandler } from './useTicketQueueErrorHandler';

export const TicketQueueEdit = () => {
  const onUpdateError = useTicketQueueErrorHandler('updateFailed');
  const onDeleteError = useTicketQueueErrorHandler('deleteFailed');

  return (
    <Edit mutationMode="pessimistic" mutationOptions={{ onError: onUpdateError }}>
      <TicketQueueForm
        toolbar={
          <EditToolbar deleteMutationOptions={{ onError: onDeleteError }} />
        }
      />
    </Edit>
  );
};
